

export const mapKeyValues = items => Array.isArray(items) ? items.map(e => ({ value: e.value, label: e.label })) : []
